import React from "react";

import Row from "./Row/";

import TableHead from "@material-ui/core/TableHead";

class Header extends React.Component {
  render() {
    return (
      <TableHead>
        <Row type="header" {...this.props} />
      </TableHead>
    );
  }
}

export default Header;
